import React from 'react';

export const RewardIcon = ({
  color = 'black',
  size = '32',
}: {
  color?: string;
  size?: string;
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={'32'}
      height={'32'}
      viewBox="0 0 32 32"
    >
      <path style={{ fill: 'none' }} d="M0 0h32v32H0z" />
      <g data-name="Groupe 5531">
        <path
          data-name="Tracé 3528"
          d="M14.048 56.671c0 1.436-2.473 2.6-5.524 2.6S3 58.107 3 56.671s2.473-2.6 5.524-2.6 5.524 1.163 5.524 2.6z"
          transform="translate(4 -42.007)"
          style={{
            stroke: color,
            strokeLinecap: 'round',
            strokeLinejoin: 'round',
            strokeWidth: '1.5px',
            fill: 'none',
          }}
        />
        <path
          data-name="Tracé 3529"
          d="M14.048 107.35c0 1.436-2.473 2.6-5.524 2.6S3 108.786 3 107.35"
          transform="translate(4 -88.963)"
          style={{
            stroke: color,
            strokeLinecap: 'round',
            strokeLinejoin: 'round',
            strokeWidth: '1.5px',
            fill: 'none',
          }}
        />
        <path
          data-name="Tracé 3530"
          d="M14.048 75.98v7.42c0 1.436-2.473 2.6-5.524 2.6S3 84.839 3 83.4v-7.42"
          transform="translate(4 -61.317)"
          style={{
            stroke: color,
            strokeLinecap: 'round',
            strokeLinejoin: 'round',
            strokeWidth: '1.5px',
            fill: 'none',
          }}
        />
        <path
          data-name="Tracé 3531"
          d="M115.089 120.992c.214.012.432.018.654.018 3.051 0 5.525-1.165 5.525-2.6"
          transform="translate(-94.784 -98.709)"
          style={{
            stroke: color,
            strokeLinecap: 'round',
            strokeLinejoin: 'round',
            strokeWidth: '1.5px',
            fill: 'none',
          }}
        />
        <path
          data-name="Tracé 3532"
          d="M100.682 87.042v7.422c0 1.436-2.473 2.6-5.524 2.6a10 10 0 0 1-3.427-.561"
          transform="translate(-74.199 -71.065)"
          style={{
            stroke: color,
            strokeLinecap: 'round',
            strokeLinejoin: 'round',
            strokeWidth: '1.5px',
            fill: 'none',
          }}
        />
        <path
          data-name="Tracé 3533"
          d="M85.112 5.6c0 1.436-2.473 2.6-5.524 2.6s-5.524-1.165-5.524-2.6S76.537 3 79.588 3s5.524 1.164 5.524 2.6z"
          transform="translate(-58.628 3.001)"
          style={{
            stroke: color,
            strokeLinecap: 'round',
            strokeLinejoin: 'round',
            strokeWidth: '1.5px',
            fill: 'none',
          }}
        />
        <path
          data-name="Tracé 3534"
          d="M115.089 58.862c.214.012.432.018.654.018 3.051 0 5.525-1.165 5.525-2.6"
          transform="translate(-94.784 -43.954)"
          style={{
            stroke: color,
            strokeLinecap: 'round',
            strokeLinejoin: 'round',
            strokeWidth: '1.5px',
            fill: 'none',
          }}
        />
        <path
          data-name="Ligne 322"
          transform="translate(15.435 8.601)"
          style={{
            stroke: color,
            strokeLinecap: 'round',
            strokeLinejoin: 'round',
            strokeWidth: '1.5px',
            fill: 'none',
          }}
          d="M0 2.633V0"
        />
        <path
          data-name="Tracé 3535"
          d="M115.089 34.915c.214.012.432.018.654.018 3.051 0 5.525-1.165 5.525-2.6v-7.424"
          transform="translate(-94.784 -16.308)"
          style={{
            stroke: color,
            strokeLinecap: 'round',
            strokeLinejoin: 'round',
            strokeWidth: '1.5px',
            fill: 'none',
          }}
        />
      </g>
    </svg>
  );
};
